export default __webpack_public_path__ + "static/media/terms.da7b44ab.md";